$(document).ready(function(){

	function SetNavStickyness(Element, InPageNav, IsSticky, BoundingRect)
	{
		if(IsSticky) 
	    {
	    	Element.classList.add("static");
			Element.style.height = BoundingRect.height+'px';
			InPageNav.style.width = BoundingRect.width+'px';
	    }
	    else
	    {
	    	Element.classList.remove("static");
			Element.style.height = '';
			InPageNav.style.width = '';
	    }
	}
	

	function HasBeenScrolledPast (el, offset) {

	    var rect = el.getBoundingClientRect();
	    if(el.classList.contains("static"))
		{
			var rect = el.parentElement.getBoundingClientRect();
		}
	    return rect.top < offset;
	}


	function HasScrolledIntoView (el) {
		//TODO(Christof): should there be an epsilon here so that a single visible line of pixels is not enough?
	    var rect = el.getBoundingClientRect();
	    return rect.top < (window.innerHeight || document.documentElement.clientHeight);
	}


	function SetScrolledStatus(Link, ScrolledPast)
	{
		if(ScrolledPast)
		{
			Link.classList.add("scrolled_to");
		}
		else
		{
			Link.classList.remove("scrolled_to");
			Link.classList.remove("selected");
		}


		const ScrolledElements = Link.parentElement.parentElement.getElementsByClassName("scrolled_to");
		const SelectionElement = Link.parentElement.parentElement.getElementsByClassName("selection")[0].getElementsByClassName("link")[0];

		for(var ScrolledElementsIndex = 0; ScrolledElementsIndex < ScrolledElements.length; ScrolledElementsIndex++)
		{
			ScrolledElements[ScrolledElementsIndex].classList.remove("selected");
		}

		if(ScrolledElements.length > 0)
		{
			const SelectedElement = ScrolledElements[ScrolledElements.length -1];
			SelectedElement.classList.add("selected");

			SelectionElement.href = SelectedElement.href;
			SelectionElement.innerText = SelectedElement.innerText.replaceAll("\n", "");
		}
	}

	function CreateStickyNav(InPageNav)
	{
		const MobileDefault = 70;
		const DesktopDefault = 64;

		const reciteMeHeader = document.getElementById("recite-header");
		const reciteMeHeight = reciteMeHeader ? reciteMeHeader.offsetHeight : 0;


		const DesktopOffset = (InPageNav.dataset.desktopOffset || DesktopDefault) - -reciteMeHeight;
		const MobileOffset = (InPageNav.dataset.mobileOffset|| MobileDefault) - -reciteMeHeight;

		const DesktopHeight = InPageNav.dataset.desktopHeight || DesktopDefault;
		const MobileHeight = InPageNav.dataset.mobileHeight || MobileDefault;

		const ThisHash = InPageNav.id.replace("in_page_nav_","");
		var ThisStyling = document.getElementById("in_page_nav_style_"+ThisHash);
		if(!ThisStyling)
		{
			ThisStyling = document.createElement("style");
		}

		ThisStyling.innerHTML = "\n"+
"		#in_page_nav_"+ThisHash+"{\n"+
"				top: "+DesktopOffset+"px;\n"+
"				height: "+DesktopHeight+"px;\n"+
"			}\n"+
"\n"+
"			@media (max-width: 991px)\n"+
"			{\n"+
"				#in_page_nav_"+ThisHash+"{\n"+
"					top: "+MobileOffset+"px};\n"+
"					height: "+MobileHeight+"px};\n"+
"				}\n"+
"			}\n";

		ThisStyling.id="in_page_nav_style"+ThisHash;

		document.head.appendChild(ThisStyling);


		const DropDown = InPageNav.getElementsByClassName("selection")[0];

		function ClearDropDowns(event)
		{
			DropDown.parentElement.classList.remove("expanded");
			document.removeEventListener("click", ClearDropDowns);
		}

		
		DropDown.addEventListener("click", function(event){
			DropDown.parentElement.classList.toggle("expanded");
			if(DropDown.parentElement.classList.contains("expanded"))
			{
				setTimeout(function(){document.addEventListener("click", ClearDropDowns)}, 50);
			}
		});

		DropDown.getElementsByClassName("link")[0].onclick=function(event){return false;};
		
		var ElementsToWatch = [];
		const Links = InPageNav.getElementsByClassName("links")[0].getElementsByClassName("link");
		for(var LinkIndex = 0; LinkIndex < Links.length; LinkIndex++)
		{
			const Link = Links[LinkIndex];

			if(document.location.pathname ==  Link.pathname && Link.hash)
			{
				const SearchID = Link.hash.replace("#","");
				const Element = document.getElementById(SearchID);
				//NOTE(Christof): only add sections to watch if they actually exist!
				if(Element && Link)
				{
					ElementsToWatch.push({Element:Element, NavElement:Link});
				}
			}
		}


		const MobileCheckOptions = {
			root:null,
			rootMargin: "-"+MobileOffset+"px 0px 0px 0px",
			threshold: 1.0,
		};


		const DesktopCheckOptions = {
			root:null,
			rootMargin: "-"+DesktopOffset+"px 0px 0px 0px",
			threshold: 1.0,
		};

		function InPageNavCheck(entries, offset)
		{
			entries.forEach(function (entry) {
			    var elem = entry.target;
			    const InPageNav = elem.getElementsByClassName("in_page_nav")[0];

			    SetNavStickyness(elem, InPageNav, !entry.isIntersecting && entry.boundingClientRect.top < offset, entry.boundingClientRect) 
			  });
		}

		function DektopInPageNavCheck(entries)
		{
			if(IsDesktop)
			{
				InPageNavCheck(entries, DesktopOffset);
			}
		}

		function MobileInPageNavCheck(entries)
		{
			if(!IsDesktop)
			{
				InPageNavCheck(entries, MobileOffset);
			}
		}


		const MobileNavObserver = new IntersectionObserver(MobileInPageNavCheck, MobileCheckOptions);
		const DesktopNavObserver = new IntersectionObserver(DektopInPageNavCheck, DesktopCheckOptions);

		MobileNavObserver.observe(InPageNav.parentElement);
		DesktopNavObserver.observe(InPageNav.parentElement);
		
		var LastScrollPosition = 0;

		function ScrollEventListener(event){
			const MAX_SCROLL_HEIGHT_BEFORE_CHECK = window.innerHeight;
			var ThisScrollPosition = window.scrollY;
			if(Math.abs(LastScrollPosition - ThisScrollPosition) > MAX_SCROLL_HEIGHT_BEFORE_CHECK)
			{
				for(var WatchIndex =0 ; WatchIndex < ElementsToWatch.length; WatchIndex++)
				{
					const thing = ElementsToWatch[WatchIndex];

					SetScrolledStatus(thing.NavElement, HasScrolledIntoView(thing.Element));
					
				}
				
				const elem = InPageNav.parentElement;
				const boundingRect = elem.getBoundingClientRect();
				if(!boundingRect.width)
				{
					boundingRect.width = boundingRect.right - boundingRect.left;
				}
				SetNavStickyness(elem, InPageNav, HasBeenScrolledPast(elem, IsDesktop ? DesktopOffset : MobileOffset), boundingRect);
				
			}
			LastScrollPosition = ThisScrollPosition;
		}

		addEventListener("scroll", ScrollEventListener);


		const NavTargetOptionsMobile = {
			root:null,
			rootMargin: "-"+MobileOffset+"px 0px 0px 0px",
			threshold: 0.05,
		};

		const NavTargetOptionsDesktop = {
			root:null,
			rootMargin: "-"+DesktopOffset+"px 0px 0px 0px",
			threshold: 0.05,
		};

		function NavTargetCheck_(entries)
		{
			entries.forEach(function (entry) {
			    var elem = entry.target;
			    //TODO(Christof): should there be an epsilon here so that a single visible line of pixels is not enough?
			    const ScrolledIntoView = (entry.boundingClientRect.top < (window.innerHeight || document.documentElement.clientHeight));
			    SetScrolledStatus(elem.NavElement, ScrolledIntoView);
			});
			   
		}

		function MobileNavTargetCheck(entries)
		{
			if(!IsDesktop)
			{
				NavTargetCheck_(entries);
			}
		}

		function DesktopNavTargetCheck(entries)
		{
			if(IsDesktop)
			{
				NavTargetCheck_(entries);
			}
		}

		const MobileTargetObserver = new IntersectionObserver(MobileNavTargetCheck, NavTargetOptionsMobile);
		const DesktopTargetObserver = new IntersectionObserver(DesktopNavTargetCheck, NavTargetOptionsDesktop);

		for(var WatchIndex =0 ; WatchIndex < ElementsToWatch.length; WatchIndex++)
		{
			const thing = ElementsToWatch[WatchIndex];
			if(thing.Element.NavElement)
			{
				console.error("duplicate navigation links for target section:", thing.Element.NavElement, thing.NavElement, thing.Element);
			}
			thing.Element.NavElement= thing.NavElement;
			DesktopTargetObserver.observe(thing.Element);
			MobileTargetObserver.observe(thing.Element);
			
		}

		var IsDesktop = true;

		function DoResize(event){
			if(window.innerWidth > 991)
			{
				IsDesktop = true;
			}
			else
			{
				IsDesktop = false;
			}

			const PageWidth = window.innerWidth || document.documentElement.clientWidth;
		
			const elem = InPageNav.parentElement;
			const boundingRect = elem.getBoundingClientRect();
			if(!boundingRect.width)
			{
				boundingRect.width = boundingRect.right - boundingRect.left;
			}
			if(elem.classList.contains('static'))
			{
				elem.style.height = boundingRect.height+'px';
				InPageNav.style.width =  boundingRect.width+'px';
			}

			const WidthExtender = elem.getElementsByClassName("width_extension")[0];
			WidthExtender.style.left = -(PageWidth - boundingRect.width)/2+'px';

			const mobile_dropdown = InPageNav.getElementsByClassName("mobile_dropdown")[0].getElementsByClassName("options")[0];
			const links = InPageNav.getElementsByClassName("links")[0];

			if(IsDesktop)
			{
				const items = mobile_dropdown.getElementsByClassName("link");
				while(items.length >0 )
				{
					links.appendChild(items[0]);
				}
			}
			else
			{
				const items = links.getElementsByClassName("link");
				while(items.length >0 )
				{
					mobile_dropdown.appendChild(items[0]);
				}
			}

			for(var WatchIndex =0 ; WatchIndex < ElementsToWatch.length; WatchIndex++)
			{
				const thing = ElementsToWatch[WatchIndex];

				SetScrolledStatus(thing.NavElement, HasScrolledIntoView(thing.Element));
				
			}
			
		}

		DoResize();

		addEventListener("resize", DoResize);


	}


	window.setupInPagNavs = function() {
		const InPageNavs = document.getElementsByClassName("in_page_nav");
		for(var NavIndex = 0; NavIndex < InPageNavs.length; NavIndex++)
		{
			const InPageNav = InPageNavs[NavIndex];
			CreateStickyNav(InPageNav);
		}
	}
	setupInPagNavs();

})